import { Page } from "@src/components/Page";
import { DrawerProvider } from "@src/contexts/drawerContext";
import { createRootRoute, Outlet } from "@tanstack/react-router";
import { Toaster } from "react-hot-toast";
import { UserProvider } from "../contexts/userContext";
import { PALETTE, SPACE } from "@src/utils/constants";
import { ResizeProvider } from "@src/contexts/resizeContext";

export const Route = createRootRoute({
  component: Root,
});

function Root() {
  return (
    <UserProvider>
      <DrawerProvider>
        <ResizeProvider>
          <Page>
            <div>
              <Toaster
                toastOptions={{
                  style: {
                    color: PALETTE.textInverted,
                    background: "linear-gradient(135deg, #381672, #4610b2)",
                    padding: `${SPACE.sm} ${SPACE.md}`,
                    fontWeight: "bold",
                  },
                }}
              />
            </div>

            <Outlet />
          </Page>
        </ResizeProvider>
      </DrawerProvider>
    </UserProvider>
  );
}
